/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    action: PropTypes.bool,
    fluid: PropTypes.bool,
    isActive: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    action: false,
    fluid: false,
    isActive: false,
};

const PageHeaderTabItem = (props) => {
    const classNames = [
        'c-tab__item',
        props.isActive ? 'is-active' : '',
        props.action ? 'c-tab__item--action' : '',
        props.fluid ? 'c-tab__item--fluid' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

PageHeaderTabItem.propTypes = propTypes;

PageHeaderTabItem.defaultProps = defaultProps;

export default PageHeaderTabItem;
